import * as React from 'react';
import { NextPage } from 'next';
import { Layout } from '../src/components/Layout/';
import { createLogger } from '@/modules/logging/logger';
import { EventProps } from '@/modules/data/types';
import { Db } from 'mongodb';
const connect = require('./api/db');
import { eventCollection } from './api/helpers';
import Sentry from '@/modules/sentry/init';
import { Schedule } from '@/components/Schedule';

let logger = createLogger({
  fileLabel: '/pages/index',
});

interface HomeProps {
  eventsData?: EventProps;
}

export async function getStaticProps() {
  try {
    const db: Db = await connect();
    const eventsData = await db.collection(eventCollection).findOne({ slug: 'cabo' });
    return {
      props: {
        eventsData: JSON.parse(JSON.stringify(eventsData)),
      },
      // Next.js will attempt to re-generate the page:
      // - When a request comes in
      // - At most once every 10 seconds
      revalidate: 10, // In seconds
    };
  } catch (e) {
    logger.error(e);
    Sentry.captureException(e);
  }
}

const HomePage: NextPage<HomeProps> = ({ eventsData }) => {
  const site = {
    title: `Refund Policy - Beyond Borders Cabo 2024`,
    header: 'Memorial Day Weekend ',
  };

  return (
    <Layout customSite data={site}>
      <>
        <section className="bg-[#2B2922]  text-white py-24">
          <section className={`py-12`}>
            <div className="flex flex-col flex-wrap items-center justify-center w-full">
              <div className="w-full ">
                <div className="flex items-center justify-center gap-1 6 w-full"></div>
              </div>
            </div>
            <div className={`flex flex-wrap gap-6 sm:gap-24 px-4 justify-center container mx-auto mt-6 `}>
              <div className="flex flex-col gap-4">
                <span className="font-solid-grooves text-center text-4xl text-white border-y border-[#FFFF4E] py-4">
                  Refund Policy
                </span>
                <p className="text-left text-lg max-w-[460px]">
                  Thank you for choosing J & B Entertainment. We value your business and strive to provide excellent
                  service. However, due to the nature of the travel industry, we have established the following no
                  refund policy to ensure fair treatment to all customers.
                </p>
                <p className="text-left text-lg max-w-[460px]">
                  <b>Reservation Cancellation</b>: Once a reservation is made and confirmed, it is considered final. We
                  do not offer refunds or reimbursements for cancellations or changes made by the customer, regardless
                  of the reason.
                </p>
                <p className="text-left text-lg max-w-[460px]">
                  <b>No-Show Policy</b>: If you fail to show up for your travel reservation without prior notice, you
                  will not be entitled to any refund or credit.
                </p>
                <p className="text-left text-lg max-w-[460px]">
                  <b>Force Majeure</b>: In the event of unforeseen circumstances beyond our control, such as natural
                  disasters, political unrest, or airline strikes, we reserve the right to modify or cancel travel
                  arrangements. In such cases, we will make reasonable efforts to provide alternative arrangements or
                  refunds, but we cannot guarantee or be held liable for any reimbursements or compensation.
                </p>
                <p className="text-left text-lg max-w-[460px]">
                  <b>Refund Exceptions</b>: Refunds may only be considered in exceptional circumstances, such as medical
                  emergencies or death of a traveler or immediate family member. In such cases, appropriate
                  documentation and evidence will be required, and refunds, if approved, will be subject to
                  administrative fees and any non-refundable costs incurred.
                </p>
                <p className="text-left text-lg max-w-[460px]">
                  <b>Change Policy</b>: If you need to make changes to your travel arrangements, such as rescheduling or
                  modifying itineraries, additional fees may apply. Changes are subject to availability and the terms
                  and conditions of our travel partners.
                </p>
                <p className="text-left text-lg max-w-[460px]">
                  <b>Customer Responsibility</b>: It is the customer’s responsibility to review and understand the terms
                  and conditions before making a reservation. By confirming a reservation with us, you acknowledge and
                  agree to abide by this no refund policy.
                </p>
                <p className="text-left text-lg max-w-[460px]">
                  Please note that this policy is applicable to all our travel services unless otherwise specified. We
                  recommend reading the specific terms and conditions provided for each travel service or package you
                  book with us.
                </p>
                <p className="text-left text-lg max-w-[460px]">
                  If you have any questions or require further clarification regarding this policy, please contact our
                  customer support team before making a reservation.
                </p>
              </div>
            </div>
          </section>
        </section>
      </>{' '}
    </Layout>
  );
};

export default HomePage;
